import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 38px 40px 40px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;
export const NoteWrapper = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  column-gap: 50px;
`;
export const VerticalLine = styled.div`
  border-left: 2px solid ${({ theme }) => theme.palette.lightBlueGrey};
  height: auto;
`;
export const TotalScoringWrapper = styled.div`
  border-radius: 8px;
  min-width: 240px;
  height: auto;
  background-color: ${({ theme }) => theme.palette.NL20};
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 73px;
    border-radius: 8px;
    padding: 10px;
  }
`;
export const ScoringContainer = styled.div`
  display: flex;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: space-between;
    align-items: center;
  }
`;
export const TooltipWrapper = styled.div`
  display: flex;
  padding: 4px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  height: 24px;
`;
export const ScoringWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;
export const ReviewContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 8px;
`;
export const PercentContainer = styled.div`
  margin-left: auto;
`;
export const TooltipTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  display: flex;
  width: 120px;
  line-height: 24px;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.D200};
`;
export const ScoringLine = styled.div`
  margin: 4px;
  min-height: 6px;
  border-radius: 4px;
  flex-direction: row-reverse;
  vertical-align: middle;
  width: 319px;
`;

export const CommentIconContainer = styled.div`
  display: flex;
  gap: 6px;
`;

export const CommentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Examination = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 8px;
  border-radius: 8px;
`;

export const SpeacialHotelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const CommentsWrapper = styled.div`
  margin-top: 20px;
  border: 1px solid ${({ theme }) => theme.palette.gray87} !important;
  border-radius: 8px;
  padding: 12px;
`;

export const MobileScoring = styled.div``;

export const MobileSpeacialHotelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-top: 20px;
`;

export const MobileSubRatingsContainer = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  width: 100%;
`;

export const MobileTripTypesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  width: 100%;
`;

export const MobileTripTypesContainer = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  width: 100%;
  justify-content: space-between;
`;

export const MobileTripTypesNameIconContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const ShowMoreButton = styled.div`
  display: flex;
  padding: 17px 24px 18px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.D400};
  margin-top: 20px;
  cursor: pointer;
  width: 245px;
  height: 58px;
  line-height: 24px;
  text-wrap: nowrap;
  margin-left: auto;
  margin-right: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 11px 24px;
    width: 100%;
    height: 40px;
    line-height: 18px;
  }
`;
